import React from 'react';
import {useTranslation} from 'react-i18next';
import Button, {ButtonSizeType} from '../../../../../incase-domain/components/button/Button';
import DropdownMenuCompact, {
    DropdownMenuCompactMenuPosition,
} from '../../../../../incase-domain/components/dropdownMenuCompact/DropdownMenuCompact';
import i18n from '../../../../../i18n';

interface LanguageHeaderItemProps {
    buttonIcon?: string;
    buttonSize?: ButtonSizeType;
    theme: 'light' | 'dark';
}

function LanguageHeaderItem({buttonIcon, buttonSize, theme}: LanguageHeaderItemProps): JSX.Element {
    const {t} = useTranslation();

    const languageToIconMap: Record<string, string> = {
        hr: 'emojione:flag-for-croatia',
        en: 'emojione:flag-for-united-kingdom',
    };

    return (
        <DropdownMenuCompact
            items={[
                [
                    {
                        label: t('header.languages.hr'),
                        icon: languageToIconMap.hr,
                        onClick: () => i18n.changeLanguage('hr'),
                        active: i18n.language === 'hr',
                    },
                    {
                        label: t('header.languages.en'),
                        icon: languageToIconMap.en,
                        onClick: () => i18n.changeLanguage('en'),
                        active: i18n.language === 'en',
                    },
                ],
            ]}
            menuPosition={DropdownMenuCompactMenuPosition.LEFT}
        >
            <Button
                color={theme === 'light' ? 'basic' : 'primary'}
                leading={buttonIcon || languageToIconMap[i18n.language] || 'solar:earth-linear'}
                size={buttonSize || 'md'}
                variant="ghost"
                square
                className="c-header__actions_icon"
            />
        </DropdownMenuCompact>
    );
}

export default LanguageHeaderItem;
